import React from 'react';
import styled from 'styled-components';
import { BodyText, Button, FlexRow, Grid, Header2Text, ModalWindow } from 'ui-toolkit';
import { ClientUrlFactory } from 'ui-toolkit/rest/ClientUrlFactory';
import Warning from 'ui-toolkit/images/warning.gif';

export interface ICheckForAvailableFundsModalProps {
  submitData: () => void;
  type: 'wire' | 'check' | 'ach' | 'internalTransfer' | string;
  handleClose: () => void;
}

export const CheckForAvailableFundsModal: React.FC<ICheckForAvailableFundsModalProps> = ({
  submitData,
  type,
  handleClose,
}) => {
  return (
    <ModalWindow contentTextAlign={'center'} minHeight={500} uitype="fit" width={720} onClose={() => handleClose()}>
      <Grid justifyItems={'center'}>
        <StyledTitle>
          <Header2Text>Not enough available funds!</Header2Text>
        </StyledTitle>
        <BodyText>
          You do not have enough available funds to send this disbursement. If more funds have come in, please match
          them now. If necessary, you may proceed anyway.
        </BodyText>
        <img src={Warning} alt={'Warning'} />
        <FlexRow justifyContent={'center'}>
          <Button intent={'secondary'} onClick={submitData} data-test-id={'proceed-button'}>
            PROCEED
          </Button>
          <Button
            intent={'primary'}
            onClick={() =>
              (window.location.href =
                type === 'wire'
                  ? ClientUrlFactory().urlFor.incomingWires()
                  : type === 'check'
                    ? ClientUrlFactory().urlFor.incomingChecks()
                    : type === 'ach'
                      ? ClientUrlFactory().urlFor.incomingAchs()
                      : type === 'internalTransfer'
                        ? ClientUrlFactory().urlFor.unrestrictedInternalTransfers()
                        : ClientUrlFactory().urlFor.escrowIndex())
            }
          >
            MATCH NOW
          </Button>
        </FlexRow>
      </Grid>
    </ModalWindow>
  );
};

const StyledTitle = styled.div`
  color: ${(props) => props.theme.colors.primary};
`;
